import React from 'react';

const Switch = ({ checked, onChange, disabled = false, ...props }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? 'checked' : 'unchecked'}
      className={`switch ${checked ? 'switch-checked' : ''}`}
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      {...props}
    >
      <span className="switch-knob" data-state={checked ? 'checked' : 'unchecked'}></span>
    </button>
  );
};

export default Switch;